var exports = {
  "d": "labelList__wdv-eh",
};

module.exports = exports;
